import React from 'react';

export const CommentHeader = ({ text }: { text: string }) => (
  <div className="CommentHeader">
    <hr />
    <span>{text}</span>
    <style jsx>{`
      .CommentHeader :global(hr) {
        border: 0;
        border-top: 1px solid #f0f0f0;
      }

      .CommentHeader {
        margin-top: 1em;
      }
    `}</style>
  </div>
);
